export default __webpack_public_path__ + "static/media/tutor.ac7f04c4.jpg";